import api from "../helper/api";

/**
 * Initiate a deposit transaction
 * @param {Object} payload - { amount, mode }
 * @returns {Promise<{payment_url: string, ...}>}
 */
export const initiateDeposit = async (payload) => {
  try {
    const response = await api.post(`deposit`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
